import {FC} from 'react';
import {Skeleton} from '@mantine/core';

import {useSelector} from '~/store/hooks';

import MainHeaderContent from './parts/MainHeaderContent';
import PersonalAreaContent from './parts/PersonalAreaContent';
import SearchHeaderContent from './parts/SearchHeaderContent';
import LightHeaderContent from './parts/LightHeaderContent';

export enum HeaderType {
  Main = 'main',
  Search = 'search',
  PersonalArea = 'personal-area',
  Light = 'light',
}

interface HeaderProps {
  variant: HeaderType;
}

const Header: FC<HeaderProps> = ({variant}) => {
  const loading = useSelector((store) => store.app.loading);

  if (loading) {
    return <Skeleton height={60} />;
  }

  switch (variant) {
    case HeaderType.Main:
      return <MainHeaderContent />;
    case HeaderType.Search:
      return <SearchHeaderContent />;
    case HeaderType.PersonalArea:
      return <PersonalAreaContent />;
    case HeaderType.Light:
    default:
      return <LightHeaderContent />;
  }
};

export default Header;
